import { action } from '@ember/object';
import Component from '@glimmer/component';
import config from 'garaje/config/environment';

interface ScreensMenuArgs {
  trackClickEvent: (trackingString: string) => void;
}

export default class ScreensMenuComponent extends Component<ScreensMenuArgs> {
  @action
  onHover(): void {
    if (config.environment === 'development') {
      return;
    }

    const { cookieDomain } = config;
    const domain = cookieDomain.includes('christmas') ? `apps.${cookieDomain}` : cookieDomain;
    void import(/* webpackIgnore: true */ `https://sapi.${domain}/s/screens-device-list`);
  }
}
